/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://t9631xd1g3.execute-api.eu-west-1.amazonaws.com/production",
            "region": "eu-west-1"
        },
        {
            "name": "authUtils",
            "endpoint": "https://yd5uns0n81.execute-api.eu-west-1.amazonaws.com/production",
            "region": "eu-west-1"
        },
        {
            "name": "utils",
            "endpoint": "https://hjfg6bs1r8.execute-api.eu-west-1.amazonaws.com/production",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://axgjp7bzevh6tihfpnumpjbh2m.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-klm25dyeq5bgrdmxjzdtlh4c2e",
    "aws_cognito_identity_pool_id": "eu-west-1:b0a1945b-ccc9-44e5-a468-f67060a6c87c",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_a6zLZEnJr",
    "aws_user_pools_web_client_id": "15qtih4dqnvvta2v9va428rro5",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "senseus-content130908-production",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
